<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Send Changelog Email :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/changelogs`">
                            <i class="fa fa-code"></i> Changelog
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/changelogs/view/${changelog.id}`">
                            <i class="fa fa-bell"></i> {{ changelog.changelog_title }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Email Users</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card">
                        <div class="card-header"><i class="fa fa-code"></i> {{ changelog.changelog_title }}: <strong>Email Users</strong></div>
                        <div class="card-body">
                            <div class="alert alert-warning" v-if="changelog.users_alerted_at">
                                This changelog has already been alerted. You cannot send it again.
                            </div>
                            <div class="alert alert-warning" v-else>
                                You are about to email <strong>{{ users.length }}</strong> active users to this changelog:

                                <ul class="list-unstyled mt-4">
                                    <li v-for="user in users">
                                        {{ user.FirstName }} {{ user.LastName }} - {{ user.email }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-footer" v-if="!changelog.users_alerted_at">
                            <button type="button" class="btn btn-sm btn-warning" v-on:click="alertChangelog()" :disabled="alerting">
                                <template v-if="!alerting">
                                    Email Users
                                </template>
                                <template v-else>
                                    Emailing...
                                </template>
                            </button>
                            <button type="button" class="btn btn-sm btn-info" v-on:click="alertChangelog(true)" :disabled="alerting">
                                <template v-if="!alerting">
                                    Send Preview to: {{ $store.state.user.email }}
                                </template>
                                <template v-else>
                                    Emailing...
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                alerting: false,
                id: this.$route.params.id,
                changelog: {},
                users: [],
                errors: {},
            }
        },

        methods: {

            getChangelog: function() {
                //Get the data
                this.$http
                    .get('/changelogs/email/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.changelog = response.data.changelog;
                        this.users = response.data.users;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            alertChangelog: function(preview = false) {
                //SHow loading
                this.alerting = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('/changelogs/email/' + this.id, {preview: preview})
                .then(response => {
                    //Email the user?
                    this.$toastr.success('Changelog Emailed');

                    //Return to main list?
                    if(!preview)
                    {
                        this.$router.push('/changelogs/view/' + this.id);
                    }
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.alerting = false;
                });
            },
        },

        mounted() {
            //Get the Changelog
            this.getChangelog();
        }
    }
</script>
